<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div>
            <div class="area_title">
                <p>내가 작성한 상담 목록</p>
                <div class="area_button">
                    <!-- <button type="button" @click="router.push({ name: 'group' })">
                        <span>내담자 그룹 관리</span>
                    </button> -->

                    <!-- <button type="button" @click="router.push({ name: 'counselBulk' })">
                        <span>프로그램 작성</span>
                    </button> -->

                    <!-- <button type="button" @click="window.alert('준비중입니다.')">
                        <img src="img/print.png" />
                        <span>PDF 출력</span>
                    </button> -->
                    <button type="button" @click="downloadFile">
                        <img src="img/excel.png" />
                        <span>Excel 다운</span>
                    </button>
                </div>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <!-- <div class="area_tab">
                        <div
                            :class="{ selected: state.dept === 0 }"
                            @click="
                                state.dept = 0;
                                router.push({ name: 'counsel', query: { dept: state.dept } });
                                fnGetList(1);
                            "
                        >
                            <span>전체</span>
                        </div>
                        <div
                            :class="{ selected: state.dept === 1 }"
                            @click="
                                state.dept = 1;
                                router.push({ name: 'counsel', query: { dept: state.dept } });
                                fnGetList(1);
                            "
                        >
                            <span>상담팀</span>
                        </div>
                        <div
                            :class="{ selected: state.dept === 3 }"
                            @click="
                                state.dept = 3;
                                router.push({ name: 'counsel', query: { dept: state.dept } });
                                fnGetList(1);
                            "
                        >
                            <span>현장팀</span>
                        </div>
                        <div
                            :class="{ selected: state.dept === 4 }"
                            @click="
                                state.dept = 4;
                                router.push({ name: 'counsel', query: { dept: state.dept } });
                                fnGetList(1);
                            "
                        >
                            <span>기타</span>
                        </div>
                        <div
                            :class="{ selected: state.dept === 99 }"
                            @click="
                                state.dept = 99;
                                router.push({ name: 'counsel', query: { dept: state.dept } });
                                fnGetList(1);
                            "
                        >
                            <span>프로그램</span>
                        </div>
                    </div> -->
                    <div class="area_search">
                        <div v-if="state.dept === 1" class="area_search_checkbox">
                            <div>
                                <div class="checkbox_wrap">
                                    <label>
                                        <input
                                            type="checkbox"
                                            :checked="state.isChild === 1"
                                            @click="
                                                state.isChild = state.isChild === 1 ? 0 : 1;
                                                fnGetList(1);
                                            "
                                        />
                                        <em></em>
                                        <span>청소년팀만</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div>
                            <label>작성일</label>
                            <div>
                                <div class="datepicker"><input type="date" id="startDate" v-model="state.startDate" @change="changeStartDate" /></div>
                                <span>~</span>
                                <div class="datepicker"><input type="date" id="endDate" v-model="state.endDate" @change="changeEndDate" /></div>
                                <button
                                    type="button"
                                    @click="
                                        setDateToToday();
                                        fnGetList(1);
                                    "
                                >
                                    오늘날짜
                                </button>
                            </div>
                        </div>
                        <div>
                            <label>검색조건1</label>
                            <div>
                                <div class="select-wrap">
                                    <select name="searchType" v-model="state.searchType1">
                                        <option value="">선택해주세요.</option>
                                        <option v-for="item in searchCondition" :value="item.key">{{ item.name }}</option>
                                    </select>
                                </div>
                                <template
                                    v-if="
                                        state.searchType1 !== 'state' &&
                                        state.searchType1 !== 'stateSub' &&
                                        state.searchType1 !== 'counselType' &&
                                        state.searchType1 !== 'result' &&
                                        state.searchType1 !== 'counselState' &&
                                        state.searchType1 !== 'modifyState' &&
                                        state.searchType1 !== 'removeState'
                                    "
                                >
                                    <input
                                        type="text"
                                        name="searchText"
                                        v-model="state.searchText1"
                                        placeholder="검색어를 입력해주세요."
                                        v-on:keyup.enter="fnGetList(1)"
                                    />
                                </template>
                                <template v-else>
                                    <div class="select-wrap">
                                        <select
                                            name="searchType"
                                            v-model="state.searchText1"
                                            v-if="state.searchType1 === 'state'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in stateList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select
                                            name="searchType"
                                            v-model="state.searchText1"
                                            v-else-if="state.searchType1 === 'stateSub'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in stateSubList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select
                                            name="searchType"
                                            v-model="state.searchText1"
                                            v-else-if="state.searchType1 === 'counselState'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in counselStateList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select
                                            name="searchType"
                                            v-model="state.searchText1"
                                            v-else-if="state.searchType1 === 'counselType'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in CommonOptions.counselTypeListForCounsel" :value="item.key">
                                                {{ item.name }}
                                            </option>
                                        </select>

                                        <select
                                            name="searchType"
                                            v-model="state.searchText1"
                                            v-else-if="state.searchType1 === 'modifyState' || state.searchType1 === 'removeState'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in CommonOptions.accessRequestStateList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select name="searchType" v-model="state.searchText1" v-else @change="fnGetList(1)">
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in resultList" :value="item.key">{{ item.name }}</option>
                                        </select>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div>
                            <label>검색조건2</label>
                            <div>
                                <div class="select-wrap">
                                    <select name="searchType" v-model="state.searchType2">
                                        <option value="">선택해주세요.</option>
                                        <option v-for="item in searchCondition" :value="item.key">{{ item.name }}</option>
                                    </select>
                                </div>
                                <template
                                    v-if="
                                        state.searchType2 !== 'state' &&
                                        state.searchType2 !== 'stateSub' &&
                                        state.searchType2 !== 'counselType' &&
                                        state.searchType2 !== 'result' &&
                                        state.searchType2 !== 'counselState' &&
                                        state.searchType2 !== 'modifyState' &&
                                        state.searchType2 !== 'removeState'
                                    "
                                >
                                    <input
                                        type="text"
                                        name="searchText"
                                        v-model="state.searchText2"
                                        placeholder="검색어를 입력해주세요."
                                        v-on:keyup.enter="fnGetList(1)"
                                    />
                                </template>
                                <template v-else>
                                    <div class="select-wrap">
                                        <select
                                            name="searchType"
                                            v-model="state.searchText2"
                                            v-if="state.searchType2 === 'state'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in stateList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select
                                            name="searchType"
                                            v-model="state.searchText2"
                                            v-else-if="state.searchType2 === 'stateSub'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in stateSubList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select
                                            name="searchType"
                                            v-model="state.searchText2"
                                            v-else-if="state.searchType2 === 'counselState'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in counselStateList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select
                                            name="searchType"
                                            v-model="state.searchText2"
                                            v-else-if="state.searchType2 === 'counselType'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in CommonOptions.counselTypeListForCounsel" :value="item.key">
                                                {{ item.name }}
                                            </option>
                                        </select>

                                        <select
                                            name="searchType"
                                            v-model="state.searchText2"
                                            v-else-if="state.searchType2 === 'modifyState' || state.searchType2 === 'removeState'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in CommonOptions.accessRequestStateList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select name="searchType" v-model="state.searchText2" v-else @change="fnGetList(1)">
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in resultList" :value="item.key">{{ item.name }}</option>
                                        </select>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div>
                            <label>검색조건3</label>
                            <div>
                                <div class="select-wrap">
                                    <select name="searchType" v-model="state.searchType3">
                                        <option value="">선택해주세요.</option>
                                        <option v-for="item in searchCondition" :value="item.key">{{ item.name }}</option>
                                    </select>
                                </div>
                                <template
                                    v-if="
                                        state.searchType3 !== 'state' &&
                                        state.searchType3 !== 'stateSub' &&
                                        state.searchType3 !== 'counselType' &&
                                        state.searchType3 !== 'result' &&
                                        state.searchType3 !== 'counselState' &&
                                        state.searchType3 !== 'modifyState' &&
                                        state.searchType3 !== 'removeState'
                                    "
                                >
                                    <input
                                        type="text"
                                        name="searchText"
                                        v-model="state.searchText3"
                                        placeholder="검색어를 입력해주세요."
                                        v-on:keyup.enter="fnGetList(1)"
                                    />
                                </template>
                                <template v-else>
                                    <div class="select-wrap">
                                        <select
                                            name="searchType"
                                            v-model="state.searchText3"
                                            v-if="state.searchType3 === 'state'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in stateList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select
                                            name="searchType"
                                            v-model="state.searchText3"
                                            v-else-if="state.searchType3 === 'stateSub'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in stateSubList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select
                                            name="searchType"
                                            v-model="state.searchText3"
                                            v-else-if="state.searchType3 === 'counselState'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in counselStateList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select
                                            name="searchType"
                                            v-model="state.searchText3"
                                            v-else-if="state.searchType3 === 'counselType'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in CommonOptions.counselTypeListForCounsel" :value="item.key">
                                                {{ item.name }}
                                            </option>
                                        </select>

                                        <select
                                            name="searchType"
                                            v-model="state.searchText3"
                                            v-else-if="state.searchType3 === 'modifyState' || state.searchType3 === 'removeState'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in CommonOptions.accessRequestStateList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select name="searchType" v-model="state.searchText3" v-else @change="fnGetList(1)">
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in resultList" :value="item.key">{{ item.name }}</option>
                                        </select>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div>
                            <label>검색조건4</label>
                            <div>
                                <div class="select-wrap">
                                    <select name="searchType" v-model="state.searchType4">
                                        <option value="">선택해주세요.</option>
                                        <option v-for="item in searchCondition" :value="item.key">{{ item.name }}</option>
                                    </select>
                                </div>
                                <template
                                    v-if="
                                        state.searchType4 !== 'state' &&
                                        state.searchType4 !== 'stateSub' &&
                                        state.searchType4 !== 'counselType' &&
                                        state.searchType4 !== 'result' &&
                                        state.searchType4 !== 'counselState'
                                    "
                                >
                                    <input
                                        type="text"
                                        name="searchText"
                                        v-model="state.searchText4"
                                        placeholder="검색어를 입력해주세요."
                                        v-on:keyup.enter="fnGetList(1)"
                                    />
                                </template>
                                <template v-else>
                                    <div class="select-wrap">
                                        <select
                                            name="searchType"
                                            v-model="state.searchText4"
                                            v-if="state.searchType4 === 'state'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in stateList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select
                                            name="searchType"
                                            v-model="state.searchText4"
                                            v-else-if="state.searchType4 === 'stateSub'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in stateSubList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select
                                            name="searchType"
                                            v-model="state.searchText4"
                                            v-else-if="state.searchType4 === 'counselType'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in CommonOptions.counselTypeListForCounsel" :value="item.key">
                                                {{ item.name }}
                                            </option>
                                        </select>

                                        <select
                                            name="searchType"
                                            v-model="state.searchText4"
                                            v-else-if="state.searchType4 === 'counselState'"
                                            @change="fnGetList(1)"
                                        >
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in counselStateList" :value="item.key">{{ item.name }}</option>
                                        </select>

                                        <select name="searchType" v-model="state.searchText4" v-else @change="fnGetList(1)">
                                            <option value="">선택해주세요.</option>
                                            <option v-for="item in resultList" :value="item.key">{{ item.name }}</option>
                                        </select>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div class="area_button">
                            <button
                                type="button"
                                @click="
                                    reset();
                                    fnGetList(1);
                                "
                            >
                                초기화
                            </button>
                            <button type="button" @click="fnGetList(1)">검색</button>
                        </div>
                    </div>
                </div>

                <div class="area_section">
                    <div class="area_table">
                        <div class="area_table_head">
                            <div class="select-wrap">
                                <select name="orderType" v-model="state.order" @change="fnGetList(1)">
                                    <option value="0">최근순</option>
                                    <option value="1">과거순</option>
                                </select>
                            </div>

                            <div class="total_length">
                                {{ $t("notice.total") }} : {{ CommonUtils.numberFormat(pageState.length) }} {{ $t("notice.count") }}
                            </div>
                        </div>
                        <div class="area_table_body">
                            <DataGrid
                                :list="pageState.list"
                                :columns="pageState.fields"
                                :totalLength="pageState.length"
                                :perPage="pageState.perPage"
                                :cntPage="pageState.cntPage"
                                :current-page="pageState.currentPage"
                                :isLoading="pageState.isLoading"
                                @onRowClick="fnRowClick"
                                @onPaging="fnGetList"
                                @onNextPage="fnGoPage"
                                @onPrevPage="fnGoPage"
                                @onFirstPage="fnGoPage"
                                @onLastPage="fnGoPage"
                            ></DataGrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <Spinner :is-full-page="true" v-if="state.isLoading"></Spinner>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="state.isShowModal = false"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        DataGrid,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        types,
        getMessageByCode,
        PageBtn,
        CommonUtils,
        CommonOptions,
        useRoute,
        Spinner,
        onActivated,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, PageBtn, DataGrid, Spinner },
        setup() {
            const global = globalStore();
            const user = userStore();
            const route = useRoute();

            const dayAgo = new Date();

            const today = new Date();
            dayAgo.setFullYear(today.getFullYear());
            dayAgo.setMonth(0);
            dayAgo.setDate(1);

            const state = reactive({
                startDate: "" as string,
                endDate: "" as string,
                searchType1: "number" as string,
                searchText1: "" as string,
                searchType2: "phone" as string,
                searchText2: "" as string,
                searchType3: "title" as string,
                searchText3: "" as string,
                searchType4: "contents" as string,
                searchText4: "" as string,
                dept: 0 as number,
                order: 0 as number,
                isChild: 0 as 0 | 1,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isLoading: false,
            });

            const searchCondition = [
                { key: "number", name: "연번" },
                { key: "name", name: "이름" },
                { key: "title", name: "제목" },
                // { key: "consultDepartment", name: "상담부서" },
                { key: "writer", name: "초기상담원" },
                { key: "counselor", name: "담당상담원" },
                { key: "state", name: "진행상황" },
                { key: "stateSub", name: "진행상황하위" },
                { key: "counselType", name: "상담유형" },
                { key: "newSuccessState", name: "성과현황 여부" },
                { key: "result", name: "조치결과" },
                { key: "phone", name: "연락처" },
                { key: "counselState", name: "승인 상태" },
                { key: "contents", name: "내용" },
                { key: "csmName", name: "작성자" },
            ];

            if (user.userInfo.auth == 6) {
                searchCondition.push({ key: "modifyState", name: "수정 권한 상태" });
                searchCondition.push({ key: "removeState", name: "삭제 권한 상태" });
            }

            const stateList = [
                { key: 0, name: "데이터 없음" },
                { key: 1, name: "진행" },
                { key: 2, name: "종결" },
                { key: 3, name: "보류" },
                { key: 4, name: "비해당" },
            ];

            const stateSubList = [
                { key: "긴급", name: "긴급" },
                { key: "집중", name: "집중" },
                { key: "유지", name: "유지" },
                { key: "모니터링", name: "모니터링" },
            ];

            const counselStateList = [
                { key: 0, name: "대기" },
                { key: 1, name: "승인" },
                { key: 2, name: "보완요청" },
            ];

            const resultList = [
                { key: "정서적지원", name: "정서적지원" },
                { key: "법률지원", name: "법률지원" },
                { key: "의료지원", name: "의료지원" },
                { key: "자활지원", name: "자활지원" },
                { key: "집단프로그램", name: "집단프로그램" },
                { key: "물적자원", name: "물적자원" },
                { key: "심리지원", name: "심리지원" },
                { key: "관련기관연계", name: "관련기관연계" },
                { key: "기타", name: "기타" },
            ];

            const fields = [
                { key: "", label: "No.", class: "text-center" },
                {
                    key: "date",
                    label: "작성일",
                    class: "text-center",
                    render: (row: any) => {
                        return CommonUtils.dateFormatYYYYMMDD(row.date, ".");
                    },
                },
                {
                    key: "clientVO.number",
                    label: "연번",
                    clickable: true,
                    class: "text-left",
                },
                // {
                //     key: "clientVO.name",
                //     label: "이름",
                //     clickable: false,
                //     class: "text-center",
                // },

                // {
                //     key: "clientVO.clientDetailVO.phone",
                //     label: "전화번호",
                //     clickable: false,
                //     class: "text-center",
                //     render: (row: any) => {
                //         return CommonUtils.convertPhoneNum(row.clientVO.clientDetailVO.phone);
                //     },
                // },

                // {
                //     key: "clientVO.clientDetailVO.birth",
                //     label: "생년월일",
                //     clickable: false,
                //     class: "text-center",
                //     render: (row: any) => {
                //         return CommonUtils.dateFormatYYYYMMDD(row.clientVO.clientDetailVO.birth, ".");
                //     },
                // },
                // { key: "consultDepartment", label: "상담부서", class: "text-center" },
                { key: "title", label: "제목", class: "text-left maxWidth400", clickable: true },
                { key: "cstype", label: "상담유형", class: "text-center" },
                { key: "csmName", label: "작성자", class: "text-center" },
                {
                    key: "clientState",
                    label: "진행상황",
                    class: "text-center",
                    render: (row: any) => {
                        let strResult = "";
                        switch (row.clientState) {
                            case 0:
                                strResult = "데이터없음";
                                break;
                            case 1:
                                strResult = "진행";
                                break;
                            case 2:
                                strResult = "종결";
                                break;
                            case 3:
                                strResult = "보류";
                                break;
                            case 4:
                                strResult = "비해당";
                                break;
                        }
                        if (row.clientState === 1 && row.stateSub && row.stateSub !== "" && row.stateSub !== "-") {
                            strResult += ` (${row.stateSub})`;
                        }
                        return strResult;
                    },
                },
                // {
                //     key: "newSuccessState",
                //     label: "성과현황",
                //     class: "text-center",
                //     render: (row: any) => {
                //         let strResult = "";
                //         switch (row.newSuccessState) {
                //             case 0:
                //                 strResult = "없음";
                //                 break;
                //             case 1:
                //                 strResult = "있음";
                //                 break;
                //         }
                //         return strResult;
                //     },
                // },
                { key: "result", label: "조치결과", class: "text-center" },
                {
                    key: "state",
                    label: "승인 상태",
                    class: "text-center",
                    render: (row: any) => {
                        let strResult = "";
                        switch (row.state) {
                            case 0:
                                strResult = "대기";
                                break;
                            case 1:
                                strResult = "승인";
                                if (row.counselDetailVO && row.counselDetailVO.opinion) {
                                    strResult += `(O)`;
                                }
                                break;
                            case 2:
                                strResult = "보완 요청";
                                break;
                        }
                        return strResult;
                    },
                },
            ];

            if (user.userInfo.auth === 6) {
                fields.push({
                    key: "strStateModify",
                    label: "수정 권한 상태",
                    class: "text-center",
                });

                fields.push({
                    key: "strStateRemove",
                    label: "삭제 권한 상태",
                    class: "text-center",
                });
            }

            const pageState = reactive({
                perPage: 10,
                cntPage: 5,
                currentPage: 1,
                list: [] as any,
                length: 0 as number,
                isLoading: false,
                fields: fields,
            });

            onMounted(() => {
                if (!route.query.dept) {
                    state.dept = 0;
                } else {
                    state.dept = Number(route.query.dept);
                }
                const query = {
                    dept: state.dept,
                    number: "",
                };

                if (route.query.number) {
                    state.searchType1 = "number";
                    state.searchText1 = String(route.query.number);
                    query.number = String(route.query.number);
                }

                router.replace({ name: "myCounsel", query: query });

                state.startDate = dayAgo.toLocaleDateString("sv-SE");
                state.endDate = today.toLocaleDateString("sv-SE");
            });

            onActivated(() => {
                initState();
                fnGetList(pageState.currentPage);
            });

            // watch(
            //     () => route.query.dept,
            //     () => {
            //         if (!route.query.dept) {
            //             state.dept = 0;
            //         } else {
            //             state.dept = Number(route.query.dept);
            //         }

            //         const query = {
            //             dept: state.dept,
            //             number: "",
            //         };

            //         if (route.query.number) {
            //             state.searchType1 = "number";
            //             state.searchText1 = String(route.query.number);
            //             query.number = String(route.query.number);
            //         }

            //         router.replace({ name: "counsel", query: query });

            //         // state.startDate = dayAgo.toLocaleDateString("sv-SE");
            //         // state.endDate = today.toLocaleDateString("sv-SE");
            //         fnGetList(1);
            //     },
            // );

            watch(
                () => state.searchType1,
                () => {
                    state.searchText1 = "";
                },
            );

            watch(
                () => state.searchType2,
                () => {
                    state.searchText2 = "";
                },
            );

            watch(
                () => state.searchType3,
                () => {
                    state.searchText3 = "";
                },
            );

            watch(
                () => state.searchType4,
                () => {
                    state.searchText4 = "";
                },
            );

            const initState = () => {
                state.isShowModal = false;
                state.modalTab = -1;
                state.modalTitle = "";
                state.modalContent = "";
                state.isLoading = false;
                pageState.list = [];
                pageState.isLoading = false;
                pageState.fields = fields;
            };
            const reset = () => {
                state.startDate = dayAgo.toLocaleDateString("sv-SE");
                state.endDate = today.toLocaleDateString("sv-SE");
                state.searchType1 = "number";
                state.searchText1 = "";
                state.searchType2 = "phone";
                state.searchText2 = "";
                state.searchType3 = "title";
                state.searchText3 = "";
                state.searchType4 = "contents";
                state.searchText4 = "";
                state.dept = 0;
                state.order = 0;
                state.isChild = 0;
            };

            const fnGetList = async (page: number) => {
                pageState.currentPage = page;
                pageState.isLoading = true;
                const param: types.counsel.ReqCounselList = {
                    page: page,
                    size: pageState.perPage,
                    searchType1: state.searchType1,
                    searchText1: state.searchText1,
                    searchType2: state.searchType2,
                    searchText2: state.searchText2,
                    searchType3: state.searchType3,
                    searchText3: state.searchText3,
                    searchType4: state.searchType4,
                    searchText4: state.searchText4,
                    isChild: state.isChild,
                    order: state.order,
                    dept: state.dept,
                    startDate: state.startDate,
                    endDate: state.endDate,
                    searchType: "",
                    searchText: "",
                };
                let res: types.ResPaging = await apiService.counsel.listForMy(param);

                if (res.returnCode === 0 && res.list) {
                    pageState.list = res.list.data;
                    pageState.length = res.list.recordsTotal;
                } else {
                    console.error(res.description);
                }
                pageState.isLoading = false;
            };

            const fnRowClick = (row: any, col: any) => {
                if (col.key === "title") {
                    if (user.userInfo.auth > 5) {
                        if (row.consultDepartmentF !== user.userInfo.team && user.userInfo.auth < 8) {
                            state.modalTab = -1;
                            state.modalTitle = "알림";
                            state.modalContent = "접근 권한이 없습니다.";
                            state.isShowModal = true;
                            return;
                        }
                        router.push({ name: "counselDetail", params: { id: row.clIdx, idx: row.coIdx } });
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "접근 권한이 없습니다.";
                        state.isShowModal = true;
                        return;
                    }
                } else if (col.key === "clientVO.number") {
                    if (user.userInfo.auth > 5) {
                        // if (row.consultDepartmentF !== user.userInfo.team && user.userInfo.auth < 8) {
                        //     state.modalTab = -1;
                        //     state.modalTitle = "알림";
                        //     state.modalContent = "접근 권한이 없습니다.";
                        //     state.isShowModal = true;
                        //     return;
                        // }
                        router.push({ name: "counselListForClient", params: { id: row.clIdx } });
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "접근 권한이 없습니다.";
                        state.isShowModal = true;
                        return;
                    }
                }
            };

            const fnGoPage = (page: number) => {
                pageState.currentPage = page;
            };

            const setDateToToday = () => {
                state.startDate = today.toLocaleDateString("sv-SE");
                state.endDate = today.toLocaleDateString("sv-SE");
            };

            const downloadFile = async () => {
                state.isLoading = true;
                try {
                    const param: types.counsel.ReqCounselList = {
                        page: 0,
                        size: 0,
                        searchType1: state.searchType1,
                        searchText1: state.searchText1,
                        searchType2: state.searchType2,
                        searchText2: state.searchText2,
                        searchType3: state.searchType3,
                        searchText3: state.searchText3,
                        searchType4: state.searchType4,
                        searchText4: state.searchText4,
                        isChild: state.isChild,
                        order: state.order,
                        dept: state.dept,
                        startDate: state.startDate,
                        endDate: state.endDate,
                        searchType: "",
                        searchText: "",
                    };
                    let res = await apiService.counsel.exportExcel(param);
                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "파일 다운로드 실패";
                    state.isShowModal = true;
                }
                state.isLoading = false;
            };
            const changeStartDate = () => {
                if (!CommonUtils.checkDateRange(state.startDate, state.endDate)) {
                    state.endDate = state.startDate;
                }
            };
            const changeEndDate = () => {
                if (!CommonUtils.checkDateRange(state.startDate, state.endDate)) {
                    state.endDate = state.startDate;
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "작성일 범위가 잘못 선택되었습니다.";
                    state.isShowModal = true;
                }
            };

            return {
                state,
                pageState,
                router,
                resultList,
                reset,
                fnRowClick,
                fnGoPage,
                fnGetList,
                CommonUtils,
                setDateToToday,
                searchCondition,
                stateList,
                stateSubList,
                CommonOptions,
                downloadFile,
                window,

                changeStartDate,
                changeEndDate,
                counselStateList,
            };
        },
    };
</script>
<style>
    .sch_list label:last-child {
        border-right: white;
    }
</style>
